import React, { FC } from 'react';
import { formatDate } from '../../../helpers/formatting/formatting';
import IArticleListItem from '../../../interfaces/articles/articleListItem';
import * as StyledArticle from './articleBoxCube.styles';

interface Props {
	article: IArticleListItem;
}

const ArticleBoxCube: FC<Props> = ({ article }) => {
	return (
		<StyledArticle.WrapperLink to={article.Url}>
			<StyledArticle.ImageWrapper>
				<StyledArticle.Image image={article.Image.Src || '/dist/images/placeholder.png?foo=bar'} />
				{article.Author && article.Author.Id !== 0 && (
					<StyledArticle.ArticleAuthorImage image={article.Author.Src} />
				)}
			</StyledArticle.ImageWrapper>
			<StyledArticle.Content>
				<StyledArticle.Date>{formatDate(article.Date)}</StyledArticle.Date>
				<StyledArticle.Title>
					{`${article.Title?.substring(0, 45)}`}
					{article.Title?.length > 45 && <span>...</span>}
				</StyledArticle.Title>
				<StyledArticle.Summary>
					{article.Summary.substring(0, 115)}
					{article.Summary.length > 115 && <span>...</span>}
				</StyledArticle.Summary>
			</StyledArticle.Content>
		</StyledArticle.WrapperLink>
	);
};

export default ArticleBoxCube;
